import { render, staticRenderFns } from "./authPop.vue?vue&type=template&id=51c8d67d&scoped=true"
import script from "./authPop.vue?vue&type=script&lang=js"
export * from "./authPop.vue?vue&type=script&lang=js"
import style0 from "./authPop.vue?vue&type=style&index=0&id=51c8d67d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c8d67d",
  null
  
)

export default component.exports